/**
 * @module common/dto/landing-order
 * @requires module:common/config/url-config~UrlConfig
 * @requires module:common/errors/incorrect-phonenumber~IncorrectPhoneNumberError
 * @requires module:common/errors/invalid-full-name~InvalidFullNameError
 * @requires module:common/errors/invalid-email~InvalEmailError
 */
import { UrlConfig } from '@/common/config';
import {
  IncorrectPhoneNumberError,
  InvalidFullNameError,
  InvalidEmailError
} from '@/common/errors';

/**
 * @classdesc DTO для отправки заявки с лендинга
 */
class LandingOrderDTO {
  /**
   * @param {Object} dto
   * @param {String} dto.fullName - ФИО
   * @param {String} dto.phoneNumber - Номер телефона
   * @param {String} dto.customEmail - Email
   * @param {String} clientId - ID клиента из Google Analytics
   * @param {String} dto.comment - Комментарий к заявке
   * @throws {module:common/errors/incorrect-phonenumber~IncorrectPhoneNumberError} если некорректно указан номер телефона
   * @throws {module:common/errors/invalid-full-name~InvalidFullNameError} если не указано имя
   * @throws {module:common/errors/invalid-email~InvalEmailError} если некорректно указан Email
   */
  constructor({ fullName, phoneNumber, customEmail, comment, clientId, service, tariff }) {
    /**
     * @member {String}
     * @default 'UkMarketing'
     */
    this.landing = 'UkMarketing';
    /**
     * @member {String}
     * @description Тип услуги
     */
    this.service = service;
    /**
     * @member {String}
     * @description Тариф
     */
    this.landingTariff = tariff;
    
    if (!fullName) {
      throw new InvalidFullNameError();
    }
    /**
     * @member {String}
     * @description ФИО
     */
    this.fullName = fullName;
    if (phoneNumber.length !== 18 || phoneNumber.indexOf('_') !== -1) {
      throw new IncorrectPhoneNumberError();
    }
    /**
     * @member {String}
     * @description Номер телефона
     */
    this.phoneNumber = phoneNumber;
    
    const emailRegExp = /.+@.+\..+/;

    if (customEmail.length && !emailRegExp.test(customEmail)) {
      throw new InvalidEmailError();
    }

    /**
     * @member {String}
     * @description Email
     */
    this.customEmail = customEmail;
    
    /**
     * @member {String}
     * @description ID клиента из Google Analytics
     */
    this.clientId = clientId;

    /**
     * @member {String}
     * @description Время, удобное для звонка клиенту
     */
    this.comment = comment;
    /**
     * @member {String}
     * @description URL для возврата
     */
    this.returnUrl = UrlConfig.baseLandingUrl;
  }
}

export default LandingOrderDTO;
